module.exports = __webpack_public_path__ + "static/img/charm_level_87.1c31b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_87.png
// module id = 7bux
// module chunks = 0